export default "__VITE_ASSET__BO62aXlQ__"